// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__mOvCi","inner":"Form_inner__1-g2U","range":"Form_range__2F2IN","name":"Form_name__1DJEi","actions":"Form_actions__2kGWb"};